import { useEffect } from "react";
import { pageViewEvent } from "../services/adobeDataLayer";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";

function ThankYouRejected() {
  useEffect(() => {
    let pushToDataLayer = async () => {
      const resp = await getValuesInLocalStorange("userData");
      DataLayerEvent(resp?.email, resp?.mobile, "", "", "", "", false);
    };
    pushToDataLayer();
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);
  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/tick.webp"}
            alt="tick"
            width="100"
            height="100"
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p>
            Thankyou for your interest in ICICI Bank Home Loan. Based on our
            check your current credit score doesn’t meet our eligibility
            criteria for an online application.
            <br></br>
            Please visit your nearest ICICI Bank branch or call 1800 1080
          </p>
        </div>
      </article>
    </>
  );
}

export default ThankYouRejected;
